import { EntityTypeOption, ID, Response } from '../../../../../_metronic/helpers'
export type Guidance = {
    id?: ID

    institutionId?: number
    subinstitutionId?: number
    employeeId?: number
    customerId?: number
    personId?: number
    guidanceTypeId?: number
    guidanceSubTypeId?: number
    guidanceResultTypeId?: number
    unitId?: number
    unitIdPerson?: number
    courseId?: number
    employeeNote?: string
    customerNote?: string
    personNote?: string
    mentorNote?: string
    managerNote?: string
    startDate?: Date
    endDate?: Date
    institutionName?: string
    subinstitutionName?: string
    employeeName?: string
    customerName?: string
    personName?: string
    academicYearId?: number
    termId?: number
    userId?: number
    publishingOptionId?: number
    courseTypeId?: number
    courseName?: string
    courseTypeName?: string
    courseSubTypeName?: string
    courseResultTypeId?: number
    isCustomer?: boolean
    isPerson?: boolean
    proficiencyTestId?: number
    guidanceTypeName?: number
    guidanceSubTypeName?: number
}

export type GuidancesQueryResponse = Response<Array<Guidance>>

export type GuidanceOption = EntityTypeOption & { courseResultTypeId?: number, customerName?: string, personId?: number, personName?: string, courseName?: string, startDate?: Date }

export const initialGuidance: Guidance = {

    institutionId: 0,
    subinstitutionId: 0,
    employeeId: undefined,
    customerId: undefined,
    personId: undefined,
    guidanceTypeId: undefined,
    guidanceSubTypeId: undefined,
    guidanceResultTypeId: undefined,
    unitId: undefined,
    unitIdPerson: undefined,
    courseId: undefined,
    employeeNote: '',
    customerNote: '',
    personNote: '',
    mentorNote: '',
    managerNote: '',
    startDate: undefined,
    endDate: undefined,
    institutionName: '',
    subinstitutionName: '',
    employeeName: '',
    customerName: '',
    personName: '',
    academicYearId: 0,
    termId: 0,
    userId: 0,
    publishingOptionId: undefined,
    courseTypeId: undefined,
    courseName: '',
    courseTypeName: '',
    courseSubTypeName: '',
    courseResultTypeId: undefined,
    proficiencyTestId: undefined
}

export const initialGuidances: Guidance[] = [{

    institutionId: 0,
    subinstitutionId: 0,
    employeeId: undefined,
    customerId: undefined,
    personId: undefined,
    guidanceTypeId: undefined,
    guidanceSubTypeId: undefined,
    guidanceResultTypeId: undefined,
    unitId: undefined,
    unitIdPerson: undefined,
    courseId: undefined,
    employeeNote: '',
    customerNote: '',
    personNote: '',
    mentorNote: '',
    managerNote: '',
    startDate: undefined,
    endDate: undefined,
    institutionName: '',
    subinstitutionName: '',
    employeeName: '',
    customerName: '',
    personName: '',
    academicYearId: 0,
    termId: 0,
    userId: 0,
    publishingOptionId: undefined,
    courseTypeId: undefined,
    courseName: '',
    courseTypeName: '',
    courseSubTypeName: '',
    courseResultTypeId: undefined,
    proficiencyTestId: undefined
}]

export enum GuidanceStatus {
    Incompleted = 0,
    Completed = 1
}